import { matchPath } from "react-router-dom";
import { combineEpics } from "redux-observable";
import history from "@ane/core/lib/CreateHistory";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { MetricsAuthoringRouteUtils } from "@ane/exp-data/lib/routes/MetricsAuthoringRoute.utils";
const draftMetricsActionTypes = {
  SET_PARTIAL_USER_CONTEXT: "SET_PARTIAL_USER_CONTEXT",
  SET_USER_CONTEXT: "SET_USER_CONTEXT"
};
const metricSetUserContext = {
  query: { paramType: "string" },
  metric: { paramType: "string" }
};
const setDraftMetricsUserContext = (userContext) => {
  return {
    type: draftMetricsActionTypes.SET_USER_CONTEXT,
    payload: userContext
  };
};
const setDraftMetricsPartialUserContext = (userContext) => {
  return {
    type: draftMetricsActionTypes.SET_PARTIAL_USER_CONTEXT,
    payload: userContext
  };
};
const produceSetDraftMetricsQueryStringSyncEpics = (history2) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    metricSetUserContext,
    setDraftMetricsUserContext,
    draftMetricsActionTypes.SET_PARTIAL_USER_CONTEXT,
    draftMetricsActionTypes.SET_USER_CONTEXT,
    (store) => store.maui.draft.metrics.user_context,
    history2,
    (pathname) => {
      const match = matchPath(pathname, {
        /**
         * User context params for draft /metric
         */
        path: `${MetricsAuthoringRouteUtils.routes.viewMetricSet.path()}/metric`
      });
      return !!pathname && !!(match == null ? void 0 : match.path);
    },
    EXP_QUERY_STRINGS
  );
  return combineEpics(...Object.values(setUserContextFromRouteQueryString));
};
const draftMetricsQueryStringEpics = produceSetDraftMetricsQueryStringSyncEpics(history);
export {
  draftMetricsQueryStringEpics,
  metricSetUserContext,
  produceSetDraftMetricsQueryStringSyncEpics,
  setDraftMetricsPartialUserContext,
  setDraftMetricsUserContext
};
//# sourceMappingURL=VivaceUserContext.epics.js.map
